/**
 * Maximum allowed difference between UI and API calculated cart totals
 * Small floating point differences can occur due to rounding
 */
export const CART_TOTAL_TOLERANCE = 1;